import { SVGProps } from 'react';

export type SvgChatProps = SVGProps<SVGSVGElement>;

export const SvgProvideFeedback = (props: SvgChatProps) => (
  <svg {...props} width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_1813_688)">
      <path
        opacity="0.5"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1 12.4995C0.447715 12.4995 4.85396e-07 12.0518 4.37114e-07 11.4995L0 6.49951C-4.82823e-08 5.94723 0.447715 5.49951 1 5.49951H5.5C5.77614 5.49951 6 5.72337 6 5.99951V11.9995C6 12.2757 5.77614 12.4995 5.5 12.4995H1Z"
        fill="#7C68FB"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.48637 13.2043C5.1142 13.2043 4.74672 13.1212 4.41075 12.9611L4.21132 12.866C3.68921 12.6172 3.35669 12.0903 3.35669 11.512L3.3567 6.06954C3.3567 5.81293 3.42253 5.56062 3.54789 5.33672L5.62523 1.62664C5.91265 1.11333 6.45502 0.79541 7.04332 0.79541C7.94092 0.79541 8.66857 1.52306 8.66857 2.42066V4.77828L11.9523 4.77827C13.18 4.77827 14.1179 5.87419 13.9283 7.08719L13.3024 11.0905C13.1122 12.3073 12.064 13.2043 10.8324 13.2043H5.48637Z"
        fill="#7C68FB"
      />
    </g>
    <defs>
      <clipPath id="clip0_1813_688">
        <rect width="14" height="14" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const SvgNegativeFeedback = (props: SvgChatProps) => (
  <svg {...props} width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_1813_708)">
      <path
        opacity="0.5"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1 8.49975C0.447715 8.49975 4.85396e-07 8.05205 4.37114e-07 7.49975L0 2.49976C-4.82823e-08 1.94748 0.447715 1.49976 1 1.49976H5.5C5.77614 1.49976 6 1.72362 6 1.99976V7.99975C6 8.27595 5.77614 8.49975 5.5 8.49975H1Z"
        fill="#7C68FB"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.48613 0.7957C5.11396 0.7957 4.74648 0.8788 4.41051 1.0389L4.21108 1.134C3.68897 1.3828 3.35645 1.9097 3.35645 2.488L3.35646 7.93046C3.35646 8.18707 3.42229 8.43938 3.54765 8.66328L5.62499 12.3734C5.91241 12.8867 6.45478 13.2046 7.04308 13.2046C7.94068 13.2046 8.66833 12.4769 8.66833 11.5793V9.22172L11.9521 9.22173C13.1798 9.22173 14.1177 8.12581 13.9281 6.91281L13.3022 2.9095C13.112 1.6927 12.0638 0.7957 10.8322 0.7957H5.48613Z"
        fill="#7C68FB"
      />
    </g>
    <defs>
      <clipPath id="clip0_1813_708">
        <rect width="14" height="14" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
